export default "__VITE_ASSET__e2e935c7__$_?react__"